module.exports = __webpack_public_path__ + "img/1.c1a90d0a.jpg";